<!--实时值-->
<template>
	<div class="virtualDeviceRTValueBody">
		<elCheckBoxTree slot="tree" :dataList='virtualDeviceList'></elCheckBoxTree>
		<div class="VirtualDeviceRTValueRigth" slot="body">
			<!--头部选择功能-->
			<div class="buttonLine">
				<label>应用类型组：</label>
				<el-select v-model="apptypeValue" multiple collapse-tags placeholder="请选择" size='small'>
					<el-option label='全选' value='全选' @click.native='selectAll'></el-option>
					<el-option v-for="item in apptypeGroups" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</div>
			<!--表格显示数据-->
			<el-table height="90%" :data="nowPage" border highlight-current-row :cell-style="cellStyle" :header-cell-style="{background:'#F5F5F5',color:'#696969'}">
				<el-table-column type="index" width="50"></el-table-column>
				<el-table-column v-for='item in columns' :prop="item.key" align='center' :label="item.name" :key="item.key" sortable></el-table-column>
			</el-table>
			<div style="width: 98%;display: flex;align-items: center;justify-content: flex-end;height: 5%;">
				<el-pagination
				@current-change='nowIndex = $event - 1'
				:page-size="pageLen"
				layout="total, prev, pager, next, jumper"
				:total="dataList.length">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
	import elCheckBoxTree from '@/components/module/tree/elCheckBoxTree.vue'
	export default {
		components: {
			elCheckBoxTree,
		},
		props: [],
		data() {
			return {
				apptypeValue: [],
				nowIndex: 0,
				nowApptypeGroups: [],
				from2name: {},
				columns: [{
					name: '设备名称',
					key: 'devicename'
				}, {
					name: '变量名称',
					key: 'variablename'
				}, {
					name: '实时值',
					key: 'value',
					getTdStyleMethod(column, index, value) {
						if(parseFloat(value) == NaN) {
							return {
								'color': '#FF9900'
							}
						}
					}
				}, {
					name: '变化时间',
					key: 'getTime'
				}, {
					name: '通讯状态',
					key: 'deviceState',
					getTdStyleMethod(column, index, value) {
						if(value == '正常') {
							return {
								'color': 'rgb(103, 194, 58)'
							}
						} else if(value == '中断') {
							return {
								'color': '#999999'
							}
						}
					}
				}]
			}
		},
		created() {
			debugPage = this
		},
		mounted() {
			this.apptypeValue = this.nowSelectAppTypeGroupIds
		},
		destroyed() {
			this.realTimeValueStore.commit("removeKeys", this.nowVariableNames)
		},
		computed: {
			nowSelectAppTypeGroupIds() {
				return this.$store.cacheStore.getters.getNowSelectAppTypeGroupIds(this.apptypeGroups)
			},
			nowVirtualDeviceList() {
				return this.$store.deviceStore.state.nowVirtualDeviceList
			},
			variableStore() {
				return this.$store.variableStore
			},
			deviceStore() {
				return this.$store.deviceStore
			},
			virtualDeviceList() {
				var data = this.$store.deviceStore.getters.getReadDeviceTree
				return isempty(data) ? [] : [deviceList(data)]
			},
			realTimeValueStore() {
				return this.$store.realTimeValueStore
			},
			variableTree() {
				if(isempty(this.nowVirtualDeviceList)) {
					return []
				}
				var variableTreeArr = []
				this.nowVirtualDeviceList.forEach(item => {
					//debugger
					var variableTree=[]
					if(item.type=="virtualDevice"){
						variableTree = this.variableStore.getters.getVariableTree(item.no)
					}
					//console.info("变量树："+JSON.stringify(variableTree));
					variableTree.forEach(tree => {
						tree.devicename = item.name
					})
					variableTreeArr.push(variableTree)
				})
				var result = []
				variableTreeArr.forEach(item => {
					result = result.concat(item)
				})
				return result
			},
			apptypeGroups() {
				//debugger
				//所有已选中的设备所具有的变量类型组
				var list = []
				var apptypeGroupIds = []
				this.variableTree.forEach(apptypeGroup => {
					if(!apptypeGroupIds.includes(apptypeGroup.id)) {
						apptypeGroupIds.push(apptypeGroup.id)
						list.push(apptypeGroup)
					}
				})
				//排序
				let list2 = []
				list.forEach(item => {
					if(item.name != "门限值") {
						list2.push(item)
					}
				})
				return list2.sort((a, b) => {
					return a.serialnum - b.serialnum
				})
			},
			nowVariableNames() {
				//当前应该显示的变量fromname列表
				var ag = this.nowApptypeGroups.map(item => {
					return item.id
				})
				var v1 = this.variableTree.filter(item => {
					return ag.includes(item.id)
				})
				if(isempty(v1)) {
					return []
				}
				var v2 = []
				v1.forEach(item => {
					item.next.forEach(i => {
						this.from2name[i.fromName] = i.name + '(' + item.unit + ')'
						v2.push(i.fromName)
					})
				})
				return v2
			},
			nowVariableList() {
				//当前应该显示的变量fromname列表
				var ag = this.nowApptypeGroups.map(item => {
					return item.id
				})
				var v1 = this.variableTree.filter(item => {
					return ag.includes(item.id)
				})
				if(isempty(v1)) {
					return []
				}
				var v2 = []
				v1.forEach(item => {
					item.next.forEach(i => {
						i.devicename = item.devicename
						v2.push(i)
					})
				})
				v2.sort((a, b) => {
					return a.typeNo - b.typeNo
				})
				return v2
			},
			pageLen() {
				return this.dataList.length < 20 ? this.dataList.length : 20
			},
			nowPage() {
				// 按照页码来返回当前应该显示的列表
				var list = this.dataList.filter((item, index) => {
					return index >= this.nowIndex * this.pageLen && index < (this.nowIndex + 1) * this.pageLen
				})
				return list
			},
			dataList() {
				//获取值
				var vl = this.realTimeValueStore.getters.getValue(this.nowVariableNames)
				var deviceList = this.nowVariableNames.map(item => item.substring(0, item.indexOf('.'))).distinct()
				var deviceStateMap = this.realTimeValueStore.getters.getDeviceState(deviceList)
				var v2 = this.realTimeValueStore.getters.getTime(this.nowVariableNames)
				//获取当前设备状态
				return this.nowVariableNames.map((item, index) => {
					var value = this.realTimeValueStore.getters.getText(item, vl[index])
					var deviceState = '--'
					switch(deviceStateMap[item.substring(0, item.indexOf('.'))]) {
						case 0:
							deviceState = '中断'
							break
						case 1:
							deviceState = '正常'
							break
					}
					var getTime = v2[index] != undefined ? new Date(parseInt(v2[index])).format('yyyy-MM-dd hh:mm:ss') : '--'
					if(isNaN(parseFloat((vl[index]))) || isnull(parseFloat((vl[index])))) {
						value = "- -"
					}
					var name = this.from2name[item] ? this.from2name[item] : item
					let deviceName = ''
					//这样拿貌似也不行，里面数据有问题this.nowVariableList[index].fromName.split('.')[0]
					this.nowVariableList.forEach(item2 => {
						if(item2.fromName == item) {
							deviceName = item2.fromName.split('.')[0]
						}
					})
					return {
						devicename: deviceName,
						variablename: name.subByFirstChar("."),
						value,
						getTime,
						deviceState,
					}
				})
			}
		},
		watch: {
			nowVariableNames(nv, ov) {
				this.realTimeValueStore.commit("removeKeys", ov)
				this.realTimeValueStore.commit("addKeys", nv)
			},
			apptypeValue(nv, ov) {
				this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds', nv)
				let list = []
				if(!isempty(nv)) {
					nv.forEach(item => {
						this.apptypeGroups.forEach(item2 => {
							if(item == item2.id) {
								list.push(item2)
							}
						})
					})
				}
				this.nowApptypeGroups = list
			},
			nowIndex(){
				this.nowPage
			}
		},
		methods: {
			selectAll() {
				//全选 先判断是否有选中的，有选中就清空
				if(this.apptypeValue.length==1) {
					this.nowApptypeGroup = this.apptypeGroups
					let idList = []
					this.apptypeGroups.forEach(item => {
						idList.push(item.id)
					})
					this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds', idList)
					this.apptypeValue = idList
				}else{
					this.nowApptypeGroup =[]
					this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds', [])
					this.apptypeValue=[]
				}
			},
			checkAppGroup(item) {
				//选中了app应用组
				this.nowApptypeGroups = item
			},
			//表格自定义样式
			cellStyle(row,column,rowIndex,columnIndex){
				//根据状态显示颜色
				if(row.column.label ==="通讯状态"){
					if(row.row.deviceState == '正常') {
						return 'color: #67C23A'
					}else{
						return 'color: #999999'
					}
				}
			},
			
		}
	}
</script>

<style scoped>
	.VirtualDeviceRTValue {
		display: flex;
		justify-content: space-between;
		align-items: center;
		background-color: white;
	}
	
	.VirtualDeviceRTValueRigth {
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
	
	.virtualDeviceRTValueBody {
		width: 100%;
		display: flex !important;
		align-items: center;
		justify-content: space-between;
		background-color: white;
	}
</style>